import { eventManager } from './eventManager';

export const setupDebugging = () => {
	if (window) {
		window.debugging = {
			eventManager,
		};
	}
};
